import JsonLd from "@/components/base/JsonLd";
import Navbar from "@/components/feature/Navbar";
import HeroSection from "./components/HeroSection";
import AboutSection from "./components/AboutSection";
import WhySection from "./components/WhySection";
import CategoryGrid from "./components/CategoryGrid";
import ComparisonTable from "./components/ComparisonTable";
import BlogPreviewSection from "./components/BlogPreviewSection";
import TrustSection from "./components/TrustSection";
import CTASection from "./components/CTASection";
import FAQSection from "./components/FAQSection";
import Footer from "./components/Footer";
import { faqItems } from "@/mocks/homeContent";

const siteUrl = import.meta.env.VITE_SITE_URL || "https://mulebuyspreadsheets.autos";

const websiteJsonLd = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: "Mulebuy Spreadsheet",
  url: siteUrl,
  description: "The ultimate product sourcing system for global buyers. Discover how the Mulebuy Spreadsheet simplifies international shopping with curated product lists, verified supplier data, and agent-assisted ordering.",
  inLanguage: "en",
  potentialAction: {
    "@type": "SearchAction",
    target: {
      "@type": "EntryPoint",
      urlTemplate: "https://kaspreadsheet.com/search?q={search_term_string}",
    },
    "query-input": "required name=search_term_string",
  },
};

const organizationJsonLd = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "Mulebuy Spreadsheet",
  url: siteUrl,
  description: "Information hub and trusted resource for spreadsheet-based product sourcing. We help global buyers discover, compare, and purchase products from verified China suppliers.",
  sameAs: ["https://kaspreadsheet.com/"],
};

const faqPageJsonLd = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqItems.map((item) => ({
    "@type": "Question",
    name: item.question,
    acceptedAnswer: {
      "@type": "Answer",
      text: item.answer,
    },
  })),
};

export default function Home() {
  return (
    <main>
      <JsonLd data={websiteJsonLd} />
      <JsonLd data={organizationJsonLd} />
      <JsonLd data={faqPageJsonLd} />
      <Navbar />
      <HeroSection />
      <AboutSection />
      <WhySection />
      <CategoryGrid />
      <ComparisonTable />
      <BlogPreviewSection />
      <TrustSection />
      <CTASection />
      <FAQSection />
      <Footer />
    </main>
  );
}